<script lang="ts" setup>
    import {onMounted,onBeforeMount, watch,reactive, computed} from 'vue';
    import {popAlert,ModalStyles} from '../../../../src/lib/Notification';
    import DropDownMenu ,{IDropDownMenu} from "../../../components/DropDownMenu.vue";   
    import {RefundArea,refundRecordTypes,IClaimEntityRefunds,IRefundReassignment,
            RefundMenuExplanation,RefundMenuActions,RefundMenuType} from '../../../../src/lib/Models/ClaimModel';
    import {ErrorReturnMessage,getClaimEntityRefunds,setRefundReassignment} from '../../../../src/lib/Api/Claim';
    import {initPinia} from '../../../../src/lib/PiniaMgr';
    import {useRefundUpdateStore} from '../../../../src/lib/Stores/RefundUpdateStore';
    import {AppScreens,PrivilegeType} from '../../../Enums/ChoiceEnums';
    import { usePrivilegesStore } from '../../../lib/Stores/PrivilegesStore'

    const refundUpdateStore = useRefundUpdateStore(initPinia());
    const privilegesStore = usePrivilegesStore(initPinia());

    const formData = reactive <
    {   
        claimID? : number,
        claimBalance?: number,
        responsiblePartyEID? :number,
        primaryPayerEID? :number,
        secondaryPayerEID? :number,
        tertiaryPayerEID? :number,
        respPartyRefund?: IClaimEntityRefunds[],
        ins1Refund?: IClaimEntityRefunds[],
        ins2Refund?: IClaimEntityRefunds[],
        ins3Refund?: IClaimEntityRefunds[],
        unaffiliatedRefunds?: IClaimEntityRefunds[],
        refundToolTip: {ResponsibleParty: string, PrimaryInsurance: string, SecondaryInsurance: string, TertiaryInsurance: string, Unknown: string, Missing: string},
        missingCredit: number,
        RefundMenuRP: IDropDownMenu[],
        RefundMenuIns1: IDropDownMenu[],
        RefundMenuIns2: IDropDownMenu[],
        RefundMenuIns3: IDropDownMenu[],
        RefundMenuUnaffiliated: IDropDownMenu[],
        RefundMenuMissing: IDropDownMenu[]
    }>({
        refundToolTip: {ResponsibleParty: "", PrimaryInsurance: "", SecondaryInsurance: "", TertiaryInsurance: "", Unknown: "", Missing: ""},
        missingCredit: 0,
        RefundMenuRP: [],
        RefundMenuIns1: [],
        RefundMenuIns2: [],
        RefundMenuIns3: [],
        RefundMenuUnaffiliated: [],
        RefundMenuMissing: []
    });
    const props = withDefaults(defineProps<{ 
        saveEnabled?: number,
        claimID? : number,
        claimBalance? : number,
        responsiblePartyEID? : number,
        primaryPayerEID? : number,
        secondaryPayerEID? : number,
        tertiaryPayerEID? : number
    }>(),
    {
        saveEnabled: 0
    });
    const updatePrivilege = computed<boolean>(() => privilegesStore.screens[AppScreens.CreditClaimSelect] >= PrivilegeType.ReadUpdate ? true : false);
    onBeforeMount(async () => {
        await privilegesStore.getScreens([AppScreens.CreditClaimSelect]);
    });
    onMounted(async () => {
        formData.claimID = props.claimID;
        formData.claimBalance = props.claimBalance;
        formData.responsiblePartyEID = props.responsiblePartyEID;
        formData.primaryPayerEID = props.primaryPayerEID;
        formData.secondaryPayerEID = props.secondaryPayerEID;
        formData.tertiaryPayerEID = props.tertiaryPayerEID;
        
    });
    watch(() => 
        [props.claimID,props.claimBalance,props.responsiblePartyEID,props.primaryPayerEID,props.secondaryPayerEID,props.tertiaryPayerEID], 
        ([newID ,newBalance, newResponsiblePartyEID,newPrimaryPayerEID,newSecondaryPayerEID,newTertiaryPayerEID], 
         [oldID ,oldBalance, oldResponsiblePartyEID,oldPrimaryPayerEID,oldSecondaryPayerEID,oldTertiaryPayerEID]) => {  
            formData.claimID = newID;
            formData.claimBalance = newBalance;
            formData.responsiblePartyEID = newResponsiblePartyEID;
            formData.primaryPayerEID = newPrimaryPayerEID;
            formData.secondaryPayerEID = newSecondaryPayerEID;
            formData.tertiaryPayerEID = newTertiaryPayerEID;
            SetRefundIcons();
        }
    );
    function ClearRefundIconInformation() : void {
        formData.refundToolTip =  {ResponsibleParty: "", PrimaryInsurance: "", SecondaryInsurance: "", TertiaryInsurance: "", Unknown: "", Missing: ""};
        formData.RefundMenuRP = [];
        formData.RefundMenuIns1 = [];
        formData.RefundMenuIns2 = [];
        formData.RefundMenuIns3 = [];
        formData.RefundMenuUnaffiliated = [];
        formData.RefundMenuMissing = []; 
        formData.respPartyRefund = [];
        formData.ins1Refund = [];
        formData.ins2Refund = [];
        formData.ins3Refund = [];
        formData.unaffiliatedRefunds = [];
    }
    async function SetRefundIcons() : Promise<void> {       
        if (!formData.claimID) {
            return;
        }
        ClearRefundIconInformation();
        const claimRefundGet = await getClaimEntityRefunds(formData.claimID); 
        if (!claimRefundGet.success) {  
            popAlert(claimRefundGet.error?.error ?? ErrorReturnMessage.refunds,"Refund Details",ModalStyles.danger);
            return;
        }  
        formData.respPartyRefund = claimRefundGet.success.filter(item => item.refundArea === RefundArea.ResponsibleParty);
        formData.ins1Refund = claimRefundGet.success.filter(item => item.refundArea === RefundArea.PrimaryInsurance); 
        formData.ins2Refund = claimRefundGet.success.filter(item => item.refundArea === RefundArea.SecondaryInsurance); 
        formData.ins3Refund = claimRefundGet.success.filter(item => item.refundArea === RefundArea.TertiaryInsurance);     
        formData.unaffiliatedRefunds = claimRefundGet.success.filter(item => item.refundArea === RefundArea.Unknown);
        const initialValue = 0;
        const refund_total = claimRefundGet.success.map(item => item.refundTotal).flat().reduce((accumulator, currentValue) => accumulator + currentValue, initialValue);
        formData.missingCredit = (refund_total + (formData.claimBalance ?? 0)) * -1;
        setRPRefundIcon();
        setIns1RefundIcon();
        setIns2RefundIcon();
        setIns3RefundIcon();
        setUnaffiliatedRefundIcon();
        setMissingRefundIcon();
    }
    function setRPRefundIcon() : void {
        if (formData.respPartyRefund) { 
            if ((formData.respPartyRefund[0]?.refundTotal ?? 0) > 0) {
                formData.refundToolTip.ResponsibleParty = refundRecordTypes[RefundArea.ResponsibleParty].iconTooltip(formData.respPartyRefund[0].payerName,formData.respPartyRefund[0].refundTotal); 
                setRefundIconMenu(RefundArea.ResponsibleParty);
            }
        }
    }
    function setIns1RefundIcon() : void {
        if (formData.ins1Refund) {
            if ((formData.ins1Refund[0]?.refundTotal ?? 0) > 0) {
                formData.refundToolTip.PrimaryInsurance = refundRecordTypes[RefundArea.PrimaryInsurance].iconTooltip(formData.ins1Refund[0].payerName,formData.ins1Refund[0].refundTotal); 
                setRefundIconMenu(RefundArea.PrimaryInsurance);
            }
        }
    }
    function setIns2RefundIcon() : void {
        if (formData.ins2Refund) {
            if ((formData.ins2Refund[0]?.refundTotal ?? 0) > 0) {
                formData.refundToolTip.SecondaryInsurance = refundRecordTypes[RefundArea.SecondaryInsurance].iconTooltip(formData.ins2Refund[0].payerName,formData.ins2Refund[0].refundTotal); 
                setRefundIconMenu(RefundArea.SecondaryInsurance);
            }
        }
    }
    function setIns3RefundIcon() : void {
        if (formData.ins3Refund) {
            if ((formData.ins3Refund[0]?.refundTotal ?? 0) > 0) {
                formData.refundToolTip.TertiaryInsurance = refundRecordTypes[RefundArea.TertiaryInsurance].iconTooltip(formData.ins3Refund[0].payerName,formData.ins3Refund[0].refundTotal); 
                setRefundIconMenu(RefundArea.TertiaryInsurance);
            }
        }
    }
    function setUnaffiliatedRefundIcon() : void {
        if (formData.unaffiliatedRefunds) {
            if (formData.unaffiliatedRefunds.length > 0) { 
                formData.refundToolTip.Unknown = refundRecordTypes[RefundArea.Unknown].iconUnaffiliatedTooltip(formData.unaffiliatedRefunds); 
                setRefundIconMenu(RefundArea.Unknown,);
            }
        }
    }
    function setMissingRefundIcon() : void {
        if (formData.missingCredit > 0) {
            formData.refundToolTip.Missing = refundRecordTypes[RefundArea.Missing].iconTooltip("Unassigned Refund",formData.missingCredit); 
            setRefundIconMenu(RefundArea.Missing);        
        }
    } 
    function setRefundIconMenu(refundID: RefundArea) : void {
        switch (refundID) {
            case RefundArea.ResponsibleParty:
                getIndividualRefundMenu(refundID,RefundMenuType.Reassign,RefundArea.PrimaryInsurance,);
                getIndividualRefundMenu(refundID,RefundMenuType.Reassign,RefundArea.SecondaryInsurance);
                getIndividualRefundMenu(refundID,RefundMenuType.Reassign,RefundArea.TertiaryInsurance); 
                break;
            case RefundArea.PrimaryInsurance:
                getIndividualRefundMenu(refundID,RefundMenuType.Reassign,RefundArea.ResponsibleParty);
                getIndividualRefundMenu(refundID,RefundMenuType.Reassign,RefundArea.SecondaryInsurance);
                getIndividualRefundMenu(refundID,RefundMenuType.Reassign,RefundArea.TertiaryInsurance);
                break;
            case RefundArea.SecondaryInsurance:
                getIndividualRefundMenu(refundID,RefundMenuType.Reassign,RefundArea.ResponsibleParty);
                getIndividualRefundMenu(refundID,RefundMenuType.Reassign,RefundArea.PrimaryInsurance); 
                getIndividualRefundMenu(refundID,RefundMenuType.Reassign,RefundArea.TertiaryInsurance);
                break;
            case RefundArea.TertiaryInsurance:
                getIndividualRefundMenu(refundID,RefundMenuType.Reassign,RefundArea.ResponsibleParty);
                getIndividualRefundMenu(refundID,RefundMenuType.Reassign,RefundArea.PrimaryInsurance);
                getIndividualRefundMenu(refundID,RefundMenuType.Reassign,RefundArea.SecondaryInsurance);
                break;
            case RefundArea.Unknown:
            case RefundArea.Missing:
                getIndividualRefundMenu(refundID,RefundMenuType.Reassign,RefundArea.ResponsibleParty);
                getIndividualRefundMenu(refundID,RefundMenuType.Reassign,RefundArea.PrimaryInsurance);
                getIndividualRefundMenu(refundID,RefundMenuType.Reassign,RefundArea.SecondaryInsurance); 
                getIndividualRefundMenu(refundID,RefundMenuType.Reassign,RefundArea.TertiaryInsurance);
                break;
        }
        if (refundID != RefundArea.Missing) {
            getIndividualRefundMenu(refundID,RefundMenuType.Break);
            getIndividualRefundMenu(refundID,RefundMenuType.Cancel); 
        }
    }
    function getIndividualRefundMenu(menuID : RefundArea, menuType : RefundMenuType, refundID?: RefundArea) : void {
        let menuValue : IDropDownMenu | undefined = GetMenuItem(menuType,refundID);
        if (!menuValue) {
            return;
        } 
        switch (menuID) {
            case RefundArea.ResponsibleParty:
                menuValue.callBack = ReassignRPRefund;
                formData.RefundMenuRP[formData.RefundMenuRP.length] = menuValue;
                break;
            case RefundArea.PrimaryInsurance:
                menuValue.callBack = ReassignPrimaryRefund;
                formData.RefundMenuIns1[formData.RefundMenuIns1.length] = menuValue;
                break;
            case RefundArea.SecondaryInsurance:
                menuValue.callBack = ReassignSecondaryRefund;
                formData.RefundMenuIns2[formData.RefundMenuIns2.length] = menuValue;
                break;
            case RefundArea.TertiaryInsurance:
                menuValue.callBack = ReassignTertiaryRefund;
                formData.RefundMenuIns3[formData.RefundMenuIns3.length] = menuValue;
                break; 
            case RefundArea.Unknown:
                menuValue.callBack = ReassignUnaffiliatedRefund;
                formData.RefundMenuUnaffiliated[formData.RefundMenuUnaffiliated.length] = menuValue;
                break;  
            case RefundArea.Missing:
                menuValue.callBack = ReassignMissingRefund;
                formData.RefundMenuMissing[formData.RefundMenuMissing.length] = menuValue;
                break;  
        }
    } 
    function GetMenuItem(menuType : RefundMenuType, refundID?: RefundArea) : IDropDownMenu | undefined {
        switch (menuType) {
            case RefundMenuType.Break:
                return {enabled: true, menuBreak: true, label: "", dataValue: RefundMenuActions.Break};
            case RefundMenuType.Cancel:
                return {enabled: true, menuBreak: false, label: "Unassign Refund", dataValue: RefundMenuActions.Cancel}; 
            case RefundMenuType.Reassign:
                if ((refundID === RefundArea.ResponsibleParty) && (formData.responsiblePartyEID)) {
                    return {enabled: true, menuBreak: false, label: "Re-assign to Resp. Party", dataValue: RefundMenuActions.ResponsibleParty};
                }
                if ((refundID === RefundArea.PrimaryInsurance) && (formData.primaryPayerEID)) {
                    return {enabled: true, menuBreak: false, label: "Re-assign to Primary", dataValue: RefundMenuActions.PrimaryInsurance};
                } 
                if ((refundID === RefundArea.SecondaryInsurance) && (formData.secondaryPayerEID)) {
                    return {enabled: true, menuBreak: false, label: "Re-assign to Secondary", dataValue: RefundMenuActions.SecondaryInsurance};
                } 
                if ((refundID === RefundArea.TertiaryInsurance) && (formData.tertiaryPayerEID)) {
                    return {enabled: true, menuBreak: false, label: "Re-assign to Tertiary", dataValue: RefundMenuActions.TertiaryInsurance};
                }
                break;
            default:
                alert("Invalid menuType in GetMenuItem");
                return;
        }
    } 
    function ReassignRPRefund(data : any) : void {
        ReassignRefund(RefundArea.ResponsibleParty,data,0);
    }
    function ReassignPrimaryRefund(data : any) : void {
        ReassignRefund(RefundArea.PrimaryInsurance,data,0);
    }
    function ReassignSecondaryRefund(data : any) : void {
        ReassignRefund(RefundArea.SecondaryInsurance,data,0);
    }
    function ReassignTertiaryRefund(data : any) : void {
        ReassignRefund(RefundArea.TertiaryInsurance,data,0);
    }
    function ReassignUnaffiliatedRefund(data : any) : void {
        ReassignRefund(RefundArea.Unknown,data,0);
    }
    function ReassignMissingRefund(data : any) : void {
        ReassignRefund(RefundArea.Missing,data,formData.missingCredit);
    }
    async function ReassignRefund(reassignmentSource : RefundArea, reassignmentAction : RefundMenuActions, reassignmentAmount : number) : Promise<void> {
        if (!formData.claimID) {
            return;
        }
        let refundReassignment : IRefundReassignment =
            {
                ClaimID: formData.claimID,
                ReassignmentSourceID: reassignmentSource,
                ReassignmentActionID: reassignmentAction,
                Amount: reassignmentAmount
            };
        const messageTitle = "Refund Details";
        const claimRefundReassignmentGet = await setRefundReassignment(refundReassignment); 
        if (!claimRefundReassignmentGet.success) {  
            popAlert(claimRefundReassignmentGet.error?.error ?? ErrorReturnMessage.reassignment,messageTitle,ModalStyles.danger);
            return;
        }  
        if (claimRefundReassignmentGet.success.errorCode !== 0) { 
            popAlert(claimRefundReassignmentGet.success.errorMessage,messageTitle,ModalStyles.danger);
            return; 
        }
        refundUpdateStore.updateRefunds();
        SetRefundIcons();
    }
</script> 
 
<template>
     <DropDownMenu
        :dropDownMenu="formData.RefundMenuRP"
        :dropDownTitle="formData.refundToolTip.ResponsibleParty"
        :otherIcon="refundRecordTypes[RefundArea.ResponsibleParty].iconClassStyle"
        :menuFooter="RefundMenuExplanation"
        :disabled="!updatePrivilege"/> 
    <DropDownMenu v-if="formData.RefundMenuIns1?.length ?? 0 > 0"
        :dropDownMenu="formData.RefundMenuIns1"
        :dropDownTitle="formData.refundToolTip.PrimaryInsurance"
        :otherIcon="refundRecordTypes[RefundArea.PrimaryInsurance].iconClassStyle"
        :menuFooter="RefundMenuExplanation"
        :disabled="!updatePrivilege"/> 
    <DropDownMenu v-if="formData.RefundMenuIns2?.length ?? 0 > 0"
        :dropDownMenu="formData.RefundMenuIns2"
        :dropDownTitle="formData.refundToolTip.SecondaryInsurance"
        :otherIcon="refundRecordTypes[RefundArea.SecondaryInsurance].iconClassStyle"
        :menuFooter="RefundMenuExplanation"
        :disabled="!updatePrivilege"/> 
    <DropDownMenu v-if="formData.RefundMenuIns3?.length ?? 0 > 0"
        :dropDownMenu="formData.RefundMenuIns3"
        :dropDownTitle="formData.refundToolTip.TertiaryInsurance"
        :otherIcon="refundRecordTypes[RefundArea.TertiaryInsurance].iconClassStyle"
        :menuFooter="RefundMenuExplanation"
        :disabled="!updatePrivilege"/> 
    <DropDownMenu v-if="formData.RefundMenuUnaffiliated?.length ?? 0 > 0"
        :dropDownMenu="formData.RefundMenuUnaffiliated"
        :dropDownTitle="formData.refundToolTip.Unknown"
        :otherIcon="refundRecordTypes[RefundArea.Unknown].iconClassStyle"
        :menuFooter="RefundMenuExplanation"
        :disabled="!updatePrivilege"/>   
    <DropDownMenu v-if="formData.RefundMenuMissing?.length ?? 0 > 0"
        :dropDownMenu="formData.RefundMenuMissing"
        :dropDownTitle="formData.refundToolTip.Missing"
        :otherIcon="refundRecordTypes[RefundArea.Missing].iconClassStyle"
        :menuFooter="RefundMenuExplanation"
        :disabled="!updatePrivilege"/> 
</template>
